module.exports = __webpack_public_path__ + "img/zxfw2.4481b16a.png";